import { formatText } from "../pushNotificationMessage";

const messages = async ({ actionType, notifyContent }) => {

    const message = {
        newEnquiry: {
            title: `Nuova inchiesta`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        declined: {
            title: `Rifiutato`,
            message: `${formatText(notifyContent['userName'])}: Prenotazione rifiutata`
        },
        approved: {
            title: `Approvato`,
            message: `${formatText(notifyContent['userName'])}: Prenotazione approvata`
        },
        newMessage: {
            title: `Nuovo messaggio`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        cancelReservation: {
            title: `La prenotazione è stata annullata`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        newBooking: {
            title: `Nuova prenotazione`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        preApprove: {
            title: `Nuova prenotazione`,
            message: `${formatText(notifyContent['userName'])}: La tua richiesta è stata pre-approvata`
        },
        listApproved: {
            title: `L'amministratore ha verificato la tua inserzione`,
            message: `${formatText(notifyContent['userName'])}: L'amministratore ha verificato il tuo annuncio ${notifyContent['listTitle']}. Pubblica il tuo annuncio per ricevere prenotazioni.`
        },
        listDeclined: {
            title: `L'amministratore ha rifiutato la tua inserzione`,
            message: `${formatText(notifyContent['userName'])}: L'amministratore ha rifiutato la tua richiesta di inserzione per ${notifyContent['listTitle']} per il motivo ${notifyContent['reason']}. Aggiorna le informazioni dell'inserzione e inviala per l'approvazione.`
        },
        noHostPayout: {
            title: `Dettagli del pagamento mancanti`,
            message: `${formatText(notifyContent['userName'])}:Aggiorna! Aggiorna le tue informazioni di pagamento per ricevere i pagamenti delle prenotazioni.`
        },
        approvedDocument: {
            title: `Documento approvato!`,
            message: `Il tuo documento è stato approvato con successo.`
        },
        rejectDocument: {
            title: `Documento rifiutato!`,
            message: `Il documento inviato è stato rifiutato dall'amministratore. Contatta l'amministratore per ulteriori informazioni.`
        }
    }

    return message[actionType]
}
export default messages;